module.exports = __webpack_public_path__ + "static/media/gaxon.00fcca8e.ttf";